import React from 'react';

import PropTypes from 'prop-types';
import { Table, Checkbox } from 'semantic-ui-react';

import _get from 'lodash/get';

import { ObjectPropType } from 'libs/proptypes';

import HelpTooltip from '../../../../../../../common/HelpTooltip';
import useBranding from '../../../../../../foundation/hooks/use-branding';
import { getDisplaySyncSetting, getPullHelpTooltip } from '../../AccountSettings.utils';

import './PullSettings.scss';

const propTypes = {
  setting: ObjectPropType.isRequired,
  name: PropTypes.string.isRequired,
  onSettingChange: PropTypes.func.isRequired,
};

const defaultProps = {};

function PullSettings({ setting, name, onSettingChange }) {
  const { brandName, menuLabel } = useBranding();

  const { pull } = setting;
  const pullSupported = _get(pull, 'supported');
  const pullEnabled = _get(pull, 'settings.enabled');

  if (!pullSupported) {
    return null;
  }

  const displayName = getDisplaySyncSetting(name, brandName, menuLabel);
  const pullHelpTooltip = getPullHelpTooltip(name, brandName, menuLabel);

  return (
    <Table.Row className="pull">
      <Table.Cell className="name">
        Sync {displayName} from Google
        <HelpTooltip title={displayName} content={pullHelpTooltip} />
      </Table.Cell>
      <Table.Cell className="toggle">
        <Checkbox
          name={name}
          toggle
          checked={pullEnabled}
          onChange={(_, { checked }) => onSettingChange({ enabled: checked })}
        />
      </Table.Cell>
    </Table.Row>
  );
}

PullSettings.propTypes = propTypes;
PullSettings.defaultProps = defaultProps;

export default PullSettings;
